import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = 'rgba(255, 247, 237, 1)';
export const BG_SECONDARY = 'rgba(187,87,109,0.7)';
export const BG_ALTERNATIVE = 'rgba(243,229,228,.61)';
export const BG_LAYER = 'rgba(255, 247, 237, 0.81)';
// Text Color
export const TEXT_PRIMARY = '#000000';
export const TEXT_SECONDARY = '#c99b6d';
export const TEXT_ALTERNATIVE = '#a43d58';
export const TEXT_BUTTON = '#FFF';

export const ASSET_COLOR = '#766963';

// Music & Navigation Color
export const NAVIGATION_COLOR = TEXT_ALTERNATIVE;
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.subHeading,
  fontWeight: '600',
  variant: 'solid',
  padding: '16px 22px',
  borderRadius: '18px',
  background: 'linear-gradient(to right, #a43d58, #bf747c)',
  color: '#FFF',
  size: 'sm',
  boxShadow: 'sm',
  fontSize: 'calc(var(--chakra-fontSizes-body) - 3px)',
  position: 'relative',
  fontStyle: 'normal',
  zIndex: '20',
  minWidth: '100px',
  _hover: {
    opacity: '.7',
  },
};
export const BUTTON_PADDING_PROPS_SMALL = {
  ...TEXT_PROPS.subHeading,
  fontWeight: '600',
  variant: 'solid',
  padding: '14px 18px',
  borderRadius: '12px',
  background: 'linear-gradient(to right, #a43d58, #bf747c)',
  color: '#FFF',
  size: 'xs',
  boxShadow: 'xs',
  fontSize: 'calc(var(--chakra-fontSizes-body) - 4px)',
  position: 'relative',
  fontStyle: 'normal',
  zIndex: '20',
  minWidth: '80px',
  _hover: {
    opacity: '.7',
  },
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
